import type { SVGProps } from "react";
import * as React from "react";

const SvgClipboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 3a1 1 0 1 0 0 2zm2 1V3zM4 20H3zM6 4V3zm2 1a1 1 0 0 0 0-2zm8 0h2V3h-2zm2 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 18 3zm.707.293A1 1 0 0 1 19 6h2a3 3 0 0 0-.879-2.121zM19 6v14h2V6zm0 14a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 21 20zm-.293.707A1 1 0 0 1 18 21v2a3 3 0 0 0 2.121-.879zM18 21H6v2h12zM6 21a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 6 23zm-.707-.293A1 1 0 0 1 5 20H3a3 3 0 0 0 .879 2.121zM5 20V6H3v14zM5 6a1 1 0 0 1 .293-.707L3.879 3.879A3 3 0 0 0 3 6zm.293-.707A1 1 0 0 1 6 5V3a3 3 0 0 0-2.121.879zM6 5h2V3H6zm3-2h6V1H9zm6 0h2a2 2 0 0 0-2-2zm0 0v2h2V3zm0 2v2a2 2 0 0 0 2-2zm0 0H9v2h6zM9 5H7a2 2 0 0 0 2 2zm0 0V3H7v2zm0-2V1a2 2 0 0 0-2 2z"
    />
  </svg>
);
export default SvgClipboard;
